import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-customer-service',
  standalone: true,
  templateUrl: '../../assets/customer-service.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamCustomerServiceIcon {}
